<template>
  <div>
    <!-- 微信认证组件 -->
    <wxAuth :share="share"></wxAuth>
    <!-- title -->
    <headers :params="hraderP"></headers>
    <!-- 搜索框 -->
    <search :param="searchParam" @callback="callback" ref="search"></search>
    <div v-show="!noData && hotList.length > 0">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :offset="80"
      @load="onLoad"
    >
      <div class="list-content">
        <van-row class="list-item" v-for="(item, index) of hotList" :key="index">
          <router-link :to="`/solutions/detail/${item.solutionId}.html`">
            <van-col :span="24"><div class="list-item-title" v-html="keywordHighlight(item.solutionName, keyWordParams.keyword)"></div></van-col>
            <van-col :span="24"><div class="list-item-describe" v-html="keywordHighlight(item.description, keyWordParams.keyword)"></div></van-col>
            <van-col :span="24" class="list-item-view"><span>{{item.pageView | myriabit}}</span>&nbsp;阅读量</van-col>
          </router-link>
        </van-row>
      </div>
    </van-list>
    </div>
    <noResult class="search-list-no" v-show="noData && hotList.length <= 0" :noResultData="noResultData" @toListSelf="toListSelf"></noResult>
  </div>
</template>

<script>
import headers from '@/components/headers'
import search from '@/components/search'
import wxAuth from '@/components/wxAuth'
import { mapState } from 'vuex'
import noResult from '@/components/noResult'
import { myriabit } from '@/filters/commonFilters'
export default {
  name: 'hadoop-list',
  components: { search, wxAuth, noResult, headers },
  filters: { myriabit },
  computed: {
    ...mapState({
      hotParams: state => state.solution.queryParams,
      hotKeyWord: state => state.solution.keyWords
    })
  },
  watch: {
    hotKeyWord (newV, old) {
      if (newV && newV.length > 0) {
        this.$data.searchParam.placeholder = newV
      }
    }
  },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '搜索',
        lefticon: true
      },
      searchParam: {
        type: 'search02',
        placeholder: '',
        callback: 'callback',
        filterType: 'sol',
        canel: false
      },
      loading: false,
      finished: false,
      noData: false,
      hotList: [],
      keyWordParams: {
        keyword: '', // 关键字搜索
        solutionType: '1,2,3', // 方案类型1:非品牌方案 2:品牌方案 3:用户上传 4：设计之家方案
        pageNum: 1, // 当前页码
        pageSize: 15, // 当前页数量
        total: 0
      },
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      }
    }
  },
  created () {
    this.$store.dispatch('SOLUTIONS_GET_KEYWORD')
  },
  methods: {
    callback (event) {
      let self = this
      if (event === '') {
        self.noData = false
        self.hotList = []
        return
      }
      self.resetHotParams(event)
      self.finished = false
      self.loading = true
      self.noData = false
      self.hotList = []
      let params = {
        page: 1,
        pageSize: 15,
        solutionType: '1,2,3',
        keyword: this.keyWordParams.keyword
      }
      if (params.keyword === '') {
        delete params.keyword
      }
      self.$store.dispatch('SOLUTIONS_GET_LIST_BY_KEYWORD', params).then(result => {
        console.log(result)
        if (result && result.status === 200 && result.data && result.data.data && result.data.data.solutions && result.data.data.solutions.length > 0) {
          self.hotList = result.data.data.solutions
          self.loading = false
          if (result.data.data.page >= result.data.data.pages) {
            self.finished = true
          }
        } else {
          self.loading = false
          self.finished = true
          self.noData = true
        }
      })
    },
    resetHotParams (key) {
      Object.assign(this.keyWordParams, {
        keyword: key || '', // 关键字搜索
        solutionType: '1,2,3', // 方案类型1:非品牌方案 2:品牌方案 3:用户上传 4：设计之家方案
        pageNum: 1, // 当前页码
        pageSize: 15, // 当前页数量
        total: 0
      })
    },
    onLoad () {
      let self = this
      self.loading = true
      self.keyWordParams.pageNum = self.keyWordParams.pageNum + 1
      let params = {
        page: this.keyWordParams.pageNum,
        pageSize: this.keyWordParams.pageSize,
        solutionType: '1,2,3',
        keyword: this.keyWordParams.keyword
      }
      if (params.keyword === '') {
        delete params.keyword
      }
      if (!self.loading) {
        return
      }
      self.$store.dispatch('SOLUTIONS_GET_LIST_BY_KEYWORD', params).then(result => {
        if (result && result.status === 200 && result.data && result.data.data && result.data.data.solutions && result.data.data.solutions.length > 0) {
          self.hotList = [...self.hotList, ...result.data.data.solutions]
          window.setTimeout(() => {
            self.loading = false
            if (result.data.data.page >= result.data.data.pages) {
              self.finished = true
            }
          }, 1000)
        } else {
          self.loading = false
          self.finished = true
        }
      })
    },
    toListSelf () {
      this.$refs.search.search02Model = ''
      this.$router.push('/solutions/list.html')
    }
  }
}
</script>

<style lang="scss" scoped>
.list-content{
  padding: 0 3%;
  background: #F5f5f5;
  .list-item{
    padding-top: 15px;
    border-bottom: 1px solid rgba(0,0,0,0.12);
    &:last-child{
       border-bottom: none;
     }
    &-title{
       font-size: 14px;
       color: #222222;
       height: 20px;
       overflow: hidden;
       text-overflow: ellipsis;
       white-space: nowrap;
     }
    &-describe{
       margin-top: 6px;
       margin-bottom: 5px;
       font-size: 13px;
       color: #999999;
       height: 18.5px;
       overflow: hidden !important;
       text-overflow: ellipsis !important;
       white-space: nowrap !important;
     }
    &-view{
       margin-bottom: 14px;
       font-size: 10px;
       span{
         color: #F8A325;
       }
     }
  }
}
.no-data-content{
  background-color: #f5f5f5;
  text-align: center;
  padding-top: 111px;
.describe-content{
p{
  font-size: 14px;
  color: #a0a0a0;
  margin: 0px;
}
}
.button-content{
button{
  margin-top: 40px;
  width: 200px;
  height: 44px;
  background-color: #1dbfda;
  color: white;
  border: none;
  border-radius: 5px;
}
}
}

</style>
<style>
  .search-list-no .noResult-link {
    background-color: #2f7bff!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/hadoop/list.vue